import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInstance";
import Swal from "sweetalert2";
export default function AdminOrderDetail() {

  const [orders, setOrders] = useState([]); // ✅ important
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const loadOrders = async () => {
      try {

        const res = await axiosInstance.get("/admin/orders/");
        setOrders(res.data);

      } catch (err) {

        console.error(err);
        alert("Failed to load order ❌");

      } finally {
        setLoading(false);
      }
    };

    loadOrders();

  }, []);



const sendCoupon = async (phone) => {

  const { value: formValues } = await Swal.fire({
    title: "Send Coupon",
    html: `
      <input id="coupon" class="swal2-input" placeholder="Coupon Code">
      <input id="discount" class="swal2-input" placeholder="Discount">
      <input id="maxuses" class="swal2-input" placeholder="Max Uses">
    `,
    focusConfirm: false,
    showCancelButton: true,
    preConfirm: () => {
      return {
        coupon_code: document.getElementById("coupon").value,
        discount: document.getElementById("discount").value,
        max_uses: document.getElementById("maxuses").value,
      };
    },
  });

  if (!formValues) return;

  try {

    const res = await axiosInstance.post(
      "/admin/send-coupon-whatsapp/",
      {
        phone,
        coupon_code: formValues.coupon_code,
        discount: formValues.discount,
        max_uses: formValues.max_uses,
      }
    );

    Swal.fire(
      "Success",
      res.data.message,
      "success"
    );

  } catch (err) {

    Swal.fire(
      "Error",
      err.response?.data?.error || "Failed",
      "error"
    );
  }
};



  if (loading) {
    return <p>Loading...</p>;
  }


return (

  <div style={{ maxWidth: 1000, margin: "auto", padding: 20 }}>

    <h2>📦 All Orders (Admin)</h2>

    {orders.length === 0 && (
      <p>No orders found</p>
    )}

    {orders.map(order => (

      <div
        key={order.id}
        style={{
          border: "1px solid #ddd",
          padding: 18,
          marginBottom: 20,
          borderRadius: 10,
          background: "#fff",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
        }}
      >

        {/* ================= HEADER ================= */}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <h3>Order #{order.id}</h3>

          <span
            style={{
              padding: "4px 10px",
              borderRadius: 20,
              fontSize: 12,
              background:
                order.status === "delivered"
                  ? "#86efac"
                  : order.status === "cancelled"
                  ? "#fecaca"
                  : "#fde047"
            }}
          >
            {order.status}
          </span>
        </div>


        {/* ================= USER ================= */}

        <p><b>👤 User:</b> {order.user}</p>
        <p><b>📞 Phone:</b> {order.phone || "N/A"}</p>
	<p><b>📍 Address:</b> {order.address || "N/A"}</p>

        {/* ================= PAYMENT ================= */}

        <p><b>💳 Payment:</b> {order.payment_status}</p>

        <p>
          <b>💰 Payable:</b> ₹{order.payable}
        </p>


        {/* ================= META ================= */}

        <p><b>📦 Type:</b> {order.order_type}</p>

        <p><b>🚚 Delivery Mode:</b> {order.delivery_mode || "N/A"}</p>

        <p><b>🏬 Pickup:</b> {order.pickup_type}</p>

        <p><b>🕒 Created:</b>{" "}
          {new Date(order.created_at).toLocaleString()}
        </p>


        {/* ================= PHARMACIST NOTE ================= */}

        {order.pharmacist_note && (
          <p style={{ marginTop: 6 }}>
            <b>📝 Note:</b> {order.pharmacist_note}
          </p>
        )}


        {/* ================= MEDICINES ================= */}

        <h4 style={{ marginTop: 15 }}>💊 Medicines</h4>

        {order.items.length === 0 && (
          <p style={{ color: "#777" }}>
            No medicines found
          </p>
        )}

        {order.items.map((item, i) => (

          <div
            key={i}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "6px 0",
              borderBottom: "1px dashed #ddd",
              fontSize: 14
            }}
          >

            {/* Name + Qty */}
            <span>
              {item.name} × {item.qty}
            </span>

            {/* Price */}
            <span>
              ₹{item.line_total}
            </span>


<div style={{ marginTop: 10 }}>

  <button
    onClick={() => sendCoupon(order.phone)}
    style={{
      background: "#16a34a",
      color: "#fff",
      border: "none",
      padding: "8px 14px",
      borderRadius: 6,
      cursor: "pointer",
      fontWeight: "bold"
    }}
  >
    🎁 Send Coupon
  </button>

</div>


            {/* Status Badge */}
            <span
              style={{
                padding: "2px 8px",
                borderRadius: 5,
                fontSize: 12,
                background:
                  item.status.includes("pending")
                    ? "#fde047"
                    : item.status.includes("call")
                    ? "#fdba74"
                    : "#86efac"
              }}
            >
              {item.status}
            </span>

          </div>
        ))}

      </div>

    ))}

  </div>
);
}
